module.exports = __webpack_public_path__ + "static/media/comedy.670f6af.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comedy.wav
// module id = XClO
// module chunks = 1